import React from 'react'
import { Button, Form, Input, Modal } from 'antd'
import validator from '../../validator'
import { FormActionFooter } from './PopupRenameFileStyled'
import { CloseOutlined, EditOutlined } from '@ant-design/icons'
import { inject, observer } from 'mobx-react'

const PopupRenameFile = props => {
  const {
    isModalVisibleRenameFile,
    handleCloseModalRenameFile,
    submitRenameFile,
    fieldsRenameFile,
    fileExt,
  } = props
  const [formRenameFile] = Form.useForm()

  const handleClose = () => {
    formRenameFile.resetFields()
    handleCloseModalRenameFile()
  }
  return (
    <Modal
      title="Đổi tên file"
      visible={isModalVisibleRenameFile}
      onOk={handleCloseModalRenameFile}
      onCancel={handleClose}
      footer={null}
      wrapClassName="custom-modal-wrapper">
      <Form
        form={formRenameFile}
        scrollToFirstError={true}
        onFinish={value => submitRenameFile(value)}
        fields={fieldsRenameFile}>
        <Form.Item
          name={'rename'}
          rules={[
            { required: true, message: ' Vui lòng nhập tên file!' },
            { validator: validator.validateCharactersCannotExceed },
          ]}>
          <Input
            placeholder={'Nhập tên file thay đổi'}
            suffix={fileExt}
            className="h-40"
          />
        </Form.Item>

        <div className="custom-modal-footer">
          <Button onClick={handleClose} className="custom-ant-button w-160">
            Huỷ bỏ
          </Button>
          <Button
            type={'primary'}
            htmlType={'submit'}
            className="custom-ant-button w-160">
            Đổi tên
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

PopupRenameFile.propTypes = {}

export default inject(
  'loadingAnimationStore',
  'fileStore'
)(observer(PopupRenameFile))
